/*
 * Paging Collection built extending backbone-pageable.
 * 
 * User: scarlson
 * Date: 01/27/2013
 * Time: 11:43 PM
 */

(function (factory) {
  if (typeof exports === 'object') {
    module.exports = factory(require('backbone'), require('underscore'), require('backbonePageable'));
  } else if (typeof define === 'function' && define.amd) {
    define(['backbone', 'underscore', 'backbonePageable'], factory);
  }
}(function (Backbone, _, backbonePageable) {
    
    return backbonePageable.extend({
        collectionProperty: null,
        
        zeroBasedPageIndex: false,
        state: {pageSize: 10},
        
        /*
        fetch: function(options) {
            return backbonePageable.prototype.fetch.call(this, options);
        },
        */
        
        getCurrentPage: function() {
            return this.state.currentPage;
        },
        
        getPageNext: function() {
            if (this.hasNext()) {
                this.getNextPage();
            }
        },
        
        getPagePrevious: function() {
            if (this.hasPrevious()) {
                this.getPreviousPage();
            }
        },
        
        getSortByValue: function() {
            return this.state.sortByValue;
        },
        
        getTotalPages: function() {
            return this.state.totalPages;
        },
        
        incrementCurrentPage: function() {
            this.state.currentPage++;
        },
        
        parse: function(response) {
            var newResponse = this.preparse(response);
            
            if (newResponse.totalRecords) {
                this.state.totalRecords = newResponse.totalRecords;
            } else if (newResponse.totalCount) {
            	this.state.totalRecords = newResponse.totalCount;
            } else {
                var totalPages = newResponse.pages || 1000;
                
                this.state.totalRecords = (totalPages * this.state.pageSize);
            }
            
            if (this.state.totalRecords > 0) {
                this.state = this._checkState(this.state);
            }
            
            if (newResponse[this.collectionProperty].length < this.state.pageSize) {
                // We got back less records than the page size - recalculate totalRecords, totalPages, and lastPage in case they
                // were initially wrong. (Sometimes we just guess # pages if server doesn't tell us.)
                this.state.totalRecords = ((this.state.currentPage-1) * this.state.pageSize) + newResponse[this.collectionProperty].length;
                this.state.totalPages = this.state.currentPage;
                this.state.lastPage = this.state.currentPage;
            }
            
            return newResponse[this.collectionProperty];
        },
        
        preparse: function(response) {
            return response;
        },
        
        reloadCurrentPage: function() {
            this.fetch();
        },
        
        setCurrentPage: function(page) {
            this.state.currentPage = page;
        },
        
        setSortByValue: function(sortByValue) {
            if (sortByValue != this.state.sortByValue) {
                this.state.sortByValue = sortByValue;
                return true;
            } else {
                return false;
            }
        },
        
        url: function () {
            return this.baseUrl + '/' + (this.state.currentPage - (this.zeroBasedPageIndex ? 1 : 0)) + '/' + this.state.pageSize + (this.state.sortByValue ? '/' + this.state.sortByValue : '');
        }
    });
}));



//////////////////
// WEBPACK FOOTER
// ./js/libs/custom/backbone/backbone-paging.js
// module id = 1710
// module chunks = 26